export default "__VITE_ASSET__590a9724__"